import { onGroundTransportActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { GroundTransportActivityCard } from "./GroundTransportActivityCard";

interface Props {
  groundTransportId: number
  config: server.dto.ActivityPanelConfig
}

export const GroundTransportActivityPanel = (props: Props) => {

  return <ActivityPanel<server.dto.GroundTransportActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.GroundTransport.ListActivity({ itemId: props.groundTransportId, page, perPage })}
    renderActivity={(activity => <GroundTransportActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onGroundTransportActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.groundTransportId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}